<app-back-button
  class="back"
  [text]="backButtonText()"
/>

<ng-content/>
